import React from 'react';
import "./faq.css"
import { Container } from '../style';
import { useTranslation } from 'react-i18next';


const FAQ = () => {
    const { t } = useTranslation();

    return (
        <Container>
            <br/>
            <br/>
            <br/>
            <main className="container">
      {/* Категории */}
      <div className="categories">
        <button className="category-button category-button--active">{t('categories.allQuestions')}</button>
        <button className="category-button">{t('categories.generalQuestions')}</button>
        <button className="category-button">{t('categories.education')}</button>
        <button className="category-button">{t('categories.membership')}</button>
        <button className="category-button">{t('categories.events')}</button>
      </div>

      {/* Поиск */}
      <div className="search">
        <input
          type="text"
          className="search__input"
          placeholder={t('search.placeholder')}
        />
      </div>

      {/* FAQ */}
      <section className="faq">
        {/* Общие вопросы */}
        <div className="faq__category">
          <h2 className="faq__category-title">{t('faq.generalQuestions')}</h2>

          <div className="faq__item faq__item--open">
            <div className="faq__question">
              <h3 className="faq__question-text">{t('faq.question1.question')}</h3>
              <div className="faq__toggle"></div>
            </div>
            <div className="faq__answer">
              <p className="faq__answer-text">{t('faq.question1.answer')}</p>
            </div>
          </div>

          <div className="faq__item">
            <div className="faq__question">
              <h3 className="faq__question-text">{t('faq.question2.question')}</h3>
              <div className="faq__toggle"></div>
            </div>
            <div className="faq__answer">
              <p className="faq__answer-text">{t('faq.question2.answer')}</p>
            </div>
          </div>
        </div>

        {/* Обучение */}
        <div className="faq__category">
          <h2 className="faq__category-title">{t('faq.education')}</h2>

          <div className="faq__item">
            <div className="faq__question">
              <h3 className="faq__question-text">{t('faq.question3.question')}</h3>
              <div className="faq__toggle"></div>
            </div>
            <div className="faq__answer">
              <p className="faq__answer-text">{t('faq.question3.answer')}</p>
            </div>
          </div>

          <div className="faq__item">
            <div className="faq__question">
              <h3 className="faq__question-text">{t('faq.question4.question')}</h3>
              <div className="faq__toggle"></div>
            </div>
            <div className="faq__answer">
              <p className="faq__answer-text">{t('faq.question4.answer')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Контактная информация */}
      <div className="contact">
        <h2 className="contact__title">{t('contact.title')}</h2>
        <p className="contact__text">{t('contact.text')}</p>
        <button className="contact__button">{t('contact.button')}</button>
      </div>
    </main>
    <br/>
            <br/>
            <br/>
        </Container>
    );
}

export default FAQ;
